/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, {useState} from 'react'
import { motion } from 'framer-motion'
import { baseURL, CDN } from '../../../constants';
import { Link } from 'react-router-dom'

const RecentResources = ({recentResource,setRecentResource,selectedResource,setSelectedResource,videoPlayerPopup,setVideoplayerPopup}) => {
    const [viewMore, setViewMore] = useState(true);

    return (
        <div className="sm:px-5 px-3 sm:py-5 py-3 mt-[13px] bg-[#F5F5FA] rounded-lg">
            <div className=" text-start ">
                <p className="sm:text-xs10 text-lg font-semibold text-[#090406]">Recent Resources</p>
            </div>
            <div className="flex flex-wrap -mx-1 mt-7">
                {recentResource.length > 0 && recentResource.filter((ele, idx) => idx < (viewMore === true ? 3:5)).map((resource, idx) => (
                    <div key={`resource${idx}`} className="lg:w-[33%] md:w-1/3 sm:w-1/2 w-full px-1 mb-2" data-bs-toggle="modal" data-bs-target="#videoModal">
                        <div className="w-full border-2 border-[#E9EDF4] p-2.5 rounded-lg cursor-pointer bg-[#ffffff] h-full flex flex-col justify-between">
                            <div className="overflow-hidden w-full rounded-lg">
                                {["jpg", "gif", "png", "svg", "jpeg", "jfif", "pjpeg", "pjp", "webp"].includes(resource.document.split(".")[resource.document.split(".").length-1])
                                    ? 
                                    (<div onClick={() => {setimageViewer(true)}}>
                                        <motion.img 
                                            initial={{ opacity: 0, scale: 0.6 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.8,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01],
                                            }} 
                                            className="hover:scale-[115%] transition-all cursor-pointer w-full"
                                            src={`${CDN}/${resource.document}`}alt="img" loading="eager"
                                            
                                        />
                                        {/* {imageviewer 
                                            && 
                                            (<ImageView
                                                src={`${CDN}/${resource.document}`}
                                                height="100" 
                                                width="200"
                                            />
                                            )} */}
                                    </div>)
                                    : ["csv", "pdf", "pptx", "excel"].includes(resource.document.split(".")[resource.document.split(".").length-1]) ? 
                                        
                                        // <iframe
                                        //     src={`${CDN}/${resource.document}`}
                                        // >                         
                                        // </iframe>  
                                        <motion.img 
                                            initial={{ opacity: 0, scale: 0.6 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.8,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01],
                                            }} 
                                            className="hover:scale-[115%] transition-all cursor-pointer w-full"
                                            src='/images/resources-img2.png' alt="img" loading="eager"
                                        
                                        />                           
                                        :<>
                                            <div className='relative'>
                                                <video className="hover:scale-[115%] transition-all cursor-pointer w-full">
                                                    <source src={`${CDN}/${resource.document}`} type={resource.document_type} />
                                                </video>
                                                <img onClick={() => {setVideoplayerPopup(true); setSelectedResource(resource)}} 
                                                    src="/images/playbutton.svg" alt="icon" 
                                                    className='absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] cursor-pointer' />
                                            </div>
                                        </>
                                }
                            </div>
                            <div>
                                <p className="text-center sm:pt-2.5 sm:text-xl text-base font-semibold more-lines2">{resource.title}</p>
                                <p className="text-center sm:pt-2.5 pt-1.5 sm:text-xs6 text-xs2 font-normal text-[#808285]">{resource.resource_category_name}</p>
                                <button 
                                    type="button" 
                                    className="sm:mt-2.5 mt-1.5 bg-[#555259] sm:text-base text-xs6 font-semibold text-[#ffffff] rounded-lg w-full sm:py-[10px] py-2"
                                    onClick={() => {
                                        window.open(`${CDN}/${resource.document}`, '_blank');
                                    }} 
                                >
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                {viewMore === false && 
                <div className="ordered-products-more xl:w-[31.3%] lg:w-[31%] md:w-[45%]  w-full h-[397px] flex items-center justify-center ml-5">
                    <div className=" bg-white rounded-[8px]  mt-5 shadow-7s">
                        <Link to={`/manage-resource`}><button className="text-sm55 py-5 px-5 text-center  font-normal text-black">View All</button> </Link>
                    </div>
                </div>
                }              
            </div>      
            <div className="w-full bg-white rounded-[8px] flex justify-center view-more-recent-resource  mt-5 shadow-7s" onClick={()=>setViewMore(!viewMore)}>
                <button className="text-sm55 py-5 text-center  font-normal text-black">{viewMore ? 'View More' : 'View Less'}</button>
                <img src="/images/sort-icon-view-more.svg" alt="sort icon" className={`mt-1 ml-2 cursor-pointer ${viewMore === false ?'rotate-180':''}`}/>
            </div>
      
        </div> 
    )
}

export default RecentResources
